import React, { useState } from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import ScheduleMeeting from './pages/ScheduleMeeting';
import { captureAndStoreUserData } from './utils/urlUtils';
import './i18n';
import * as amplitude from '@amplitude/analytics-browser';
import SensorDetailForm from './pages/SensorDetailForm';
import customTheme from './theme';
import { useTranslation } from 'react-i18next';
import Dashboard from './components/Dashboard';
import IframeMap from './components/IframeMap';
function App() {
  const { t, i18n } = useTranslation();
  const [selectedSensor, setSelectedSensor] = useState(null);
  const [viewMode, setViewMode] = useState('list'); // 'list', 'form', 'dashboard'

  React.useEffect(() => {
    captureAndStoreUserData();
    amplitude.init('b12254885379276c0c80eef832fd1170');
    const userData = JSON.parse(localStorage.getItem('userData') || '{}');
    if(userData.language){
      i18n.changeLanguage(userData.language);
    }
    
    if(userData.userId){
      amplitude.setUserId(userData.userId);
    }
  }, []);


  return (
    <ChakraProvider theme={customTheme}>
      <Router>
        <Routes>
        <Route path="/iframe/request-sensor" element={<SensorDetailForm iframe={true}/> } />
        <Route path="/request-sensor" element={<SensorDetailForm/> } />
          <Route path="/schedule-meeting" element={<ScheduleMeeting/> } />
          <Route path="/sensors" element={<Dashboard />} /> 
          <Route path="/iframe" element={
            <Home iframe={true} />
            }/>
          <Route path="/iframeMap" element={<IframeMap />} />
          <Route path="/" element={
            <Home />
            }/>
          {/* Add more routes as necessary */}
        </Routes>
      </Router>
    </ChakraProvider>
  );
}

export default App;
